<template>
  <div class="CloudElectricity">
    <BannerVideo :video-url="$StaticFileUrl + '/mp/video/saasdsAdviserVideo_2.mp4'">
      <div class="title wow fadeInDown" data-wow-duration="1s">SaaS电商服务</div>
      <div class="desc wow fadeInDown" data-wow-duration="1s">满足企业多应用场景，助力企业搭建电商生态环境</div>
      <div class="flex-row flex-col-center">
        <div class="btn-red wow flipInX" data-wow-duration="1s" style="margin-top: 100px">立即体验</div>
      </div>
    </BannerVideo>
  </div>
</template>

<script>
import WOW from 'wowjs'
import BannerVideo from '@/components/BannerVideo'

/**
 * @author  XuHongli
 * @date  2022/12/28 10:12
 * @version 1.0
 * @description
 */
export default {
  name: 'CloudElectricity',
  components: {BannerVideo},
  mounted() {
    new WOW.WOW().init()
  }
}
</script>

<style scoped>

</style>
